import { useContext, useEffect, useMemo, useState } from "react";
import stateContext from "../Context/StateContext";

export const DescriptionDetails = () => {
  const globalState = useContext(stateContext);
  useEffect(() => {
    const totalWeight = globalState.textWeight + globalState.chainWeight;
    if (globalState.chainCharmSide === "None")
      globalState.setPendantWeight(totalWeight);
    let charmWeight = calculateChainCharmWeight(
      globalState.chainCharmSide,
      globalState.activeCharm?.size || 0
    );
    let weight = charmWeight + totalWeight;
    weight = weight.toFixed(2);
    globalState.setPendantWeight(Number(weight));
  }, [
    globalState.textWeight,
    globalState.chainWeight,
    globalState.chainCharmSide,
    globalState.activeCharm,
    globalState.currentRawPlateSize,
  ]);
  const description = useMemo(() => {
    if (
      !globalState.text ||
      !globalState.selectedMetalData ||
      !globalState.selectedFontData?.name ||
      !globalState.selectedChainData
    ) {
      return "";
    }

    // Collect charms, diamonds, etc.
    const extras = [];

    if (
      globalState.selectedCharm &&
      globalState.selectedCharm !== "None" &&
      globalState.selectedCharm !== "shape-none"
    ) {
      extras.push(globalState.selectedCharm);

      if (globalState.charmColorName) {
        extras.push(globalState.charmColorName);
      } else if (globalState.charmColor) {
        extras.push(globalState.charmColor);
      }
    }

    if (globalState.chainCharmSide && globalState.chainCharmSide !== "None") {
      extras.push(globalState.chainCharmSide);

      if (globalState.activeCharm.charm) {
        extras.push(globalState.activeCharm.charm);
      }

      if (globalState.activeCharm.size) {
        extras.push(globalState.activeCharm.size);
      }
    }

    if (globalState.noOfDotDiamond && globalState.diamondType) {
      extras.push(`${globalState.noOfDotDiamond} ${globalState.diamondType}`);
    }

    // Build description
    let desc = `تمتعي بإطلالة راقية مع عقد من الذهب عيار 18، يحمل اسم (${globalState.text}) بخط (${globalState.selectedFontData.name}) مميز، ومعدن (${globalState.selectedMetalData.name}) بلمسة ذهبية رائعة.`;

    if (globalState.fontThickness) {
      desc += ` بـسماكة (${globalState.fontThickness}mm) التي تعكس الفخامة،`;
    }

    if (extras.length > 0) {
      desc += ` وإضافة (${extras.join(", ")})`;
    }

    if (globalState.selectedChainData.label) {
      desc += ` وسلسال إيطالي (${globalState.selectedChainData.label})،`;
    }

    desc += ` لتكمل جمال تصميمك. قلادة فريدة مصممة بتقنية الليزر تمنحك أناقة لا مثيل لها في كل مناسبة.`;

    desc += `الوزن التقريبي للقلادة هو ${globalState.pendantWeight.toFixed(
      2
    )} جرام.`;
    return desc;
  }, [
    globalState.text,
    globalState.fontThickness,
    globalState.selectedMetalData,
    globalState.selectedFontData,
    globalState.selectedChainData,
    globalState.selectedCharm,
    globalState.charmColorName,
    globalState.charmColor,
    globalState.chainCharmSide,
    globalState.activeCharm,
    globalState.noOfDotDiamond,
    globalState.diamondType,
    globalState.pendantWeight,
  ]);

  useEffect(() => {
    if (globalState.text && globalState.description !== description) {
      globalState.setDescription(description);
    } else if (!globalState.text && globalState.description !== "") {
      globalState.setDescription("");
    }
  }, [
    globalState.text,
    globalState.description,
    description,
    globalState.setDescription,
  ]);

  return null;
};

const calculateChainCharmWeight = (chainCharmSide, size) => {
  if (!chainCharmSide || !size) return 0;

  // Extract numeric value from string like "2 mm"
  const sizeVal = parseFloat(size);

  // Define weight mapping
  const weightMap = {
    2: 0.2,
    3: 0.2,
    4: 0.3,
  };

  // Get weight for size
  const baseWeight = weightMap[sizeVal] || 0;

  // Double if side is Both
  const multiplier = chainCharmSide === "Both" ? 2 : 1;
  return baseWeight * multiplier;
};
